<template>
  <Catalogs
    title="Статусы исполнителей"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'WorkerStatusAdd'"
    :route-edit="'WorkerStatusEdit'"
    :route-view="'WorkerStatusView'"
    :route-path="'/worker_statuses'"
    :can-edit="canEditWorkerStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'worker-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'worker-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getWorkerStatuses(data);
    },
    canEditWorkerStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.worker-status-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.worker-status-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerStatuses/WorkerStatuses.vue